import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthActions } from 'authOld/hooks';
import { mapSwitchUsersForm } from 'authOld/mappers';
import { ISwitchUsersForm, IUserAutocomplete } from 'authOld/types';
import { getMostRecentUsers, login, saveMostRecentUsers } from 'authOld/utils';
import { useNotification } from 'coreOld/hooks/useNotification';

import SwitchUsersFormView from './SwitchUsersFormView';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const SwitchUsersForm = ({ isOpen, onClose }: IProps) => {
  const [user, setUser] = useState<IUserAutocomplete | null>(null);
  const [mostRecentUsers, setMostRecentUsers] = useState<IUserAutocomplete[]>([]);

  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { impersonate } = useAuthActions();

  useEffect(() => {
    const mostRecentUsers = getMostRecentUsers();

    if (mostRecentUsers) {
      setMostRecentUsers(mostRecentUsers);
    }
  }, [isOpen]);

  const onSubmit = () => async (data: ISwitchUsersForm) => {
    const { success, impersonatedUser } = await impersonate(mapSwitchUsersForm(data));

    if (!success) {
      return;
    }

    saveMostRecentUsers(impersonatedUser);

    await login(navigate, showNotification);
  };

  const chooseUser = async (user: IUserAutocomplete) => {
    setUser(user);

    await onSubmit()({ user });
  };

  return (
    <SwitchUsersFormView
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      chooseUser={chooseUser}
      selectedUser={user}
      mostRecentUsers={mostRecentUsers}
    />
  );
};

export default SwitchUsersForm;
